import React, { useState, useEffect, useMemo } from 'react'
import { Table, TableHead, TableRow, TableCell, TextField, InputAdornment, IconButton, Button } from '@mui/material'
import { Search as SearchIcon, KeyboardArrowRight } from '@mui/icons-material'

import { PATHS } from '../../constants'
import { isMobile } from '../../Utilities/isMobile'
import { displayNameWithSpace } from '../../Utilities/japaneseStringUtils'
import { AxiosWithAuth } from '../../Utilities/authenticationService'
import useDebounce from '../../useDebounce'

const UserSearch = ({ path, history, customActionButton, showSignUpButton = false }) => {
    const [search, setSearch] = useState('')
    const [searchResults, setSearchResults] = useState([])
    const [searchData, setSearchData] = useState([])

    const searchRequest = () => {
        AxiosWithAuth.post('/users/search', { user: { search } }).then(res => {
            setSearchData(res.data)
        })
    }

    const searchResultsWithComponents = useMemo(() => {
        return searchData.map(user => {
            const component = (
                <TableRow key={user.id} onClick={() => {history.push(path + user.id)}} style={{ cursor: 'pointer' }}>
                    <TableCell>{displayNameWithSpace(user)}</TableCell>
                    <TableCell>{user.emp_cd}</TableCell>
                    <TableCell>{user.company?.company_name || '-'}</TableCell>
                    <TableCell align="right">
                        {customActionButton ? customActionButton(user) : (
                            <IconButton onClick={() => history.push(path + user.id)}>
                                <KeyboardArrowRight />
                            </IconButton>
                        )}
                    </TableCell>
                </TableRow>
            )
            return { ...user, component }
        })
    }, [searchData, customActionButton, path, history])

    useEffect(() => {
        setSearchResults(searchResultsWithComponents)
    }, [searchResultsWithComponents])

    const debouncedSearchRequest = useDebounce(searchRequest)

    return (
        <>
            <div
                style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: isMobile() ? 'column' : 'row',
                    justifyContent: showSignUpButton && !isMobile() ? 'space-between' : undefined,
                    alignItems: 'flex-start',
                    gap: '1rem',
                    marginTop: '1rem',
                    flexWrap: 'wrap'
                }}
            >
                <TextField
                    size="small"
                    sx={{
                        flex: isMobile() ? '1 1 100%' : '0 1 50%',
                        minWidth: 0,
                        maxWidth: isMobile() ? '100%' : '50%',
                        '& .MuiInputBase-root': { height: 42 }
                    }}
                    placeholder="ユーザー検索"
                    InputLabelProps={{
                        shrink: true
                    }}
                    value={search}
                    onChange={e => {
                        debouncedSearchRequest()
                        setSearch(e.target.value)
                    }}
                    data-testid="user-search-box"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <IconButton>
                                    <SearchIcon />
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                />
                {showSignUpButton && (
                    <Button
                        data-tour="user-signup"
                        onClick={e => {
                            e.preventDefault()
                            history.push(PATHS.signup)
                        }}
                        variant="outlined"
                        color="paloBlue"
                        sx={{
                            height: 42,
                            width: 'fit-content',
                            whiteSpace: 'nowrap',
                            flexShrink: 0,
                            marginTop: isMobile() ? 0 : undefined
                        }}
                    >
                        ユーザー新規会員登録
                    </Button>
                )}
            </div>

            {searchResults.length > 0 && (
                <Table sx={{ width: '100%', marginTop: '1rem' }} size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>氏名</TableCell>
                            <TableCell>社員番号</TableCell>
                            <TableCell>会社</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    {searchResults.slice(0, 100).map(u => u.component)}
                </Table>
            )}
        </>
    )
}

export default UserSearch
